import { notificationService } from "client-app-core";
import * as t from "./actionTypes.js";
export { removeDockedCameraAndState } from "orion-components/Dock/Actions/index.js";
import { newNotificationAlert } from "../../actions.js";

export function startNotificationStream() {
	return function (dispatch) {
		notificationService.streamMyActiveNotifications(function (err, response) {
			if (err) {
				console.log(err);
			} else {
				switch (response.type) {
					case "initial-batch": {
						const notifications = response.changes.map(item => item.new_val);
						dispatch(initialNotificationsReceived(notifications));
						break;
					}
					case "change-batch": {
						const notifications = response.changes.map(item => {
							if (item.type === "remove") {
								item.old_val["remove"] = true;
								return item.old_val;
							}
							// Adding toasts for new notifications if enabled.
							if (item.type === "add") {
								const notificationEnabled =
									item.new_val?.display?.type && item.new_val?.display?.type !== "none";
								if (notificationEnabled) {
									dispatch(newNotificationAlert(item.new_val));
								}
							}
							return item.new_val;
						});
						dispatch(notificationBatchReceived(notifications));
						break;
					}
					default:
				}
			}
		});
	};
}

export const initialNotificationsReceived = notifications => {
	return {
		notifications,
		type: t.INITIAL_NOTIFICATIONS_RECEIVED
	};
};

export const notificationBatchReceived = notifications => {
	return {
		notifications,
		type: t.NOTIFICATION_BATCH_RECEIVED
	};
};

export const closeNotification = (notificationId, serviceType) => {
	return dispatch => {
		notificationService.closeNotification(notificationId, (err, response) => {
			if (err) {
				console.error("Error closing notification:", err);
			}
		});
	};
};

export const closeBulkNotifications = (notificationIds, serviceType) => {
	return dispatch => {
		notificationService.closeBulkNotifications(notificationIds, (err, response) => {
			if (err) {
				console.error("Error closing notifications:", err);
			}
		});
	};
};
